import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import { ENG_CAPABILITIES, TECH_BADGES, IMAGES } from "../data/site";

export default function SoftwareEngineeringSection() {
  return (
    <section className="relative overflow-hidden bg-[#07111F] py-24 md:py-32 grain" data-testid="software-engineering-section">
      <div className="pointer-events-none absolute -right-32 top-10 h-[30rem] w-[30rem] rounded-full opacity-20 blur-3xl accent-bg" />
      <div className="container-x relative grid items-center gap-16 lg:grid-cols-2">
        <div>
          <SectionHeading
            eyebrow="Software Engineering"
            title="Engineering built to scale."
            dark
            max="max-w-xl"
          />
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-400">
            We focus on business outcomes and engineering quality — building systems
            that stay reliable, secure and maintainable as they grow.
          </p>

          <div className="mt-8 grid gap-x-6 gap-y-3 sm:grid-cols-2">
            {ENG_CAPABILITIES.map((c, i) => {
              const Icon = c.icon;
              return (
                <motion.div
                  key={c.label}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: (i % 2) * 0.05 }}
                  className="flex items-center gap-3"
                  data-testid={`eng-capability-${i}`}
                >
                  <Icon size={16} className="text-cyan-300" strokeWidth={1.8} />
                  <span className="text-sm text-slate-300">{c.label}</span>
                </motion.div>
              );
            })}
          </div>

          <div className="mt-9 flex flex-wrap gap-2.5" data-testid="tech-badges">
            {TECH_BADGES.map((t, i) => (
              <motion.span
                key={t}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.03 }}
                className="rounded-full border border-white/10 bg-white/5 px-4 py-1.5 font-mono text-xs text-slate-300"
                data-testid={`tech-badge-${i}`}
              >
                {t}
              </motion.span>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="pointer-events-none absolute -inset-4 rounded-[2.5rem] accent-bg opacity-20 blur-2xl" />
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10">
            <img
              src={IMAGES.engineering}
              alt="SefKam software engineer building scalable systems"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#07111F] via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 rounded-2xl border border-white/10 bg-[#07111F]/80 p-4 backdrop-blur">
              <p className="font-mono text-[11px] text-emerald-300">deploy · pipeline: passing</p>
              <p className="mt-1 text-sm text-slate-300">Cloud-native, containerized, continuously delivered.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
